import { StorageType, useBrowserStorage } from '@/hooks/useBrowserStorage';
import { useLocalStorage } from '@/hooks/useLocalStorage';

export const usePersistedAccessCodeId = () => {
  const [rememberMe] = useLocalStorage('rememberMe', false);

  const [accessCodeId] = useBrowserStorage('accessCodeId', '', rememberMe ? StorageType.Local : StorageType.Session);

  return accessCodeId;
};
